import { Box } from '@mui/material';
import { Link } from 'react-router';

import routes from '@/assets/constants/routes-no.ts';
import Page from '@/components/Page/index.ts';
import StaticPageLayout from '@/components/StaticPageLayout/index.ts';

export default function Terms() {
  return (
    <Page title="Krymp gjelden vilkår">
      <StaticPageLayout
        title="Vilkår for Scooprs kampanje «Krymp gjelden»"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'Krymp gjelden',
            url: routes.SEPTEMBER_2026_COMPETITION,
          },
          {
            text: 'Vilkår for Scooprs kampanje «Krymp gjelden»',
            url: null,
          },
        ]}
        subtitle="Dato for siste versjon: 28.08.2026"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <h3>1 – Vilkår for Scooprs kampanje «Krymp gjelden»</h3>
          <p>
            I perioden september–november 2026 avholder Scoopr AS («Scoopr») en trekning om
            innfrielse av gjeld. Scoopr «tar regninga» – inntil 1&nbsp;000&nbsp;000 kr av én heldig
            vinners rentebærende gjeld. Deltakere kan i løpet av Trekningsperioden oppnå
            tilleggslodd gjennom kampanjeaktiviteter, jf. punkt 1.4b. Disse vilkårene gjelder for
            deltakelse i trekningen.
          </p>

          <h3>1.1 – Krav for deltakelse</h3>
          <p>
            Trekningen er tilgjengelig for personer over 18 år, som har tilgang til BankID og som er
            bosatt i Norge. Deltakeren må ha en rentebærende forbruks- og/eller kredittkortgjeld
            over 1&nbsp;000 kr på registreringstidspunktet, i tillegg til å søke om lavere rente via
            Scoopr innenfor tidsperioden til kampanjen.
          </p>
          <p>
            Deltakere melder seg på trekningen ved å bekrefte deltakelse via Scoopr-løsningen
            (f.eks. «Søk og delta», «Se tilbud og delta», «Delta og avslutt» eller tilsvarende),
            godkjenne disse vilkårene, og gi samtykke til at Scoopr henter ut informasjon fra
            Gjeldsregisteret. Deltakelse i trekningen bekreftes på e-post etter at søknaden om
            refinansiering er gjennomført.
          </p>
          <p>
            Det er krav om at deltakeren oppretter en «Min Scoopr»-bruker og søker om lavere rente
            via Scoopr. Det koster ingenting å delta i trekningen, og det er ingen krav om å flytte
            gjelden sin for å delta.
          </p>
          <p>
            Vilkårene for Min Scoopr finnes <Link to={routes.TERMS_OF_USE_MIN_SCOOPR}>her</Link>.
            Deltakeren kan når som helst avslutte sin brukerkonto etter at trekningen er avsluttet.
          </p>
          <p>
            Ved å delta i trekningen og akseptere premien, aksepterer vinneren samtidig at fornavn,
            alder, bosted (by/kommune) og premiebeløp kan brukes i Scooprs markedsføring.
            Opplysningene vil ikke bli benyttet i en kombinasjon som identifiserer vinneren, med
            mindre dette avtales særskilt med vinneren.
          </p>
          <p>
            Ansatte i Scoopr og deres ektefeller, samboere, foreldre, søsken eller barn kan ikke
            delta i trekningen. Deltakere som ikke oppfyller kravene, vil bli nektet lodd og/eller
            premie, og utbetalt premie vil bli krevd tilbakebetalt. Scoopr forbeholder seg retten
            til å endre krav for deltakelse, men endringen vil kun ha virkning for deltakere som
            deltar etter at endringen er gjort.
          </p>
          <p>
            Scoopr har rett til å diskvalifisere deltakere som opptrer i strid med disse vilkårene
            eller som forsøker å manipulere trekningen, herunder ved opprettelse av flere
            brukerkontoer, juks, svindel eller annen uærlig opptreden. Diskvalifisering medfører tap
            av retten til å motta premie, og allerede utbetalt premie kan kreves tilbake.
          </p>

          <h3>1.2 – Om premien</h3>
          <p>Det trekkes én (1) vinner i «Krymp gjelden».</p>
          <p>
            Premien innebærer at Scoopr innfrir inntil 1&nbsp;000&nbsp;000 kr av vinnerens
            rentebærende gjeld som er registrert på registreringstidspunktet. Premien kan dekke
            forbrukslån, kredittkortgjeld, boliglån, billån, kjøretøyslån og studielån.
          </p>
          <p>Premien dekker kun gjeld som er registrert på deltakeren som privatperson.</p>
          <p>
            Premien kan kun benyttes til innfrielse av gjeld som var etablert og registrert hos
            kreditor før 1. september 2026.
          </p>
          <p>Følgende gjeldstyper er ikke omfattet av premien:</p>
          <ul className="list-disc pl-6">
            <li>fellesgjeld i borettslag,</li>
            <li>privat lån (gjeld mellom privatpersoner).</li>
          </ul>
          <p>
            Scoopr forbeholder seg retten til å nekte innfrielse av gjeld dersom Scoopr, etter eget
            skjønn, vurderer at gjelden stammer fra eller er tilknyttet ulovlig virksomhet.
          </p>
          <p>
            Beløpet innfris direkte hos banken(e) hvor gjelden er registrert. Innfrielse skjer
            normalt i løpet av en uke etter trekning. Dersom gjelden er fordelt over flere banker
            eller produkttyper, velger Scoopr hvilken gjeld som prioriteres innfridd. Produkter med
            høyeste rente prioriteres først. Det er ikke anledning til å få beløpet utbetalt i
            kontanter, eller i form av andre ytelser.
          </p>

          <h3>1.3 – Vilkår for mottak av premie</h3>
          <p>
            Vinneren kontaktes av Scoopr på telefon og e-post. For å motta premien må vinneren innen
            5 virkedager etter å ha blitt kontaktet:
          </p>
          <ul className="list-disc pl-6">
            <li>
              fremlegge dokumentasjon på gjelden (f.eks. låneavtale, kontoutskrift eller
              tilsvarende),
            </li>
            <li>
              oppgi nødvendige opplysninger knyttet til gjelden, herunder beløp, KID og kontonummer
              til kreditor.
            </li>
          </ul>
          <p>
            Scoopr kan om nødvendig innhente ytterligere dokumentasjon eller bekreftelse direkte fra
            kreditor før premien utbetales. Dersom vinneren ikke oppfyller kravene innen fristen,
            bortfaller retten til premie.
          </p>
          <p>
            Vinnere er selv ansvarlig for å rapportere gevinsten til skattemyndighetene, samt
            overholde andre lovpålagte krav i forbindelse med gevinsten.
          </p>

          <h3>1.4 – Varighet og trekning</h3>
          <p>
            Deltakere som søker om lavere rente via Scoopr i perioden fra 1. september 2026 til 16.
            november 2026 innen kl. 12:00 (Europe/Oslo) («Trekningsperioden») er med i trekningen.
            Det trekkes en vinner den 16. november 2026 kl. 12:00 (Europe/Oslo).
          </p>
          <p>
            Vinneren trekkes tilfeldig ved at alle deltakere får tildelt et deltakernummer.
            Trekningen gjøres gjennom tilfeldig trekning ved bruk av «random number generator
            service».
          </p>

          <h3>1.4b – Tilleggslodd ved kampanjeaktiviteter</h3>
          <p>
            I løpet av Trekningsperioden kan Scoopr invitere utvalgte deltakere til å gjennomføre én
            eller flere aktiviteter knyttet til sitt lånetilbud. Aktivitetene kan gjennomføres via
            Min Scoopr, SMS eller e-post, og kan for eksempel bestå i å se gjennom et aktivt
            lånetilbud, svare på spørsmål om tilbudsstatus eller gi tilbakemelding på mottatte
            tilbud.
          </p>
          <p>
            Deltakere som gjennomfører en invitert aktivitet innen fristen angitt i den aktuelle
            invitasjonen, kan tildeles ett eller flere tilleggslodd, som spesifisert i invitasjonen.
            Det maksimale antallet tilleggslodd en deltaker kan motta i løpet av hele
            Trekningsperioden er to (2).
          </p>
          <p>
            Scoopr avgjør fritt hvilke deltakere som inviteres, hvilke aktiviteter som kvalifiserer,
            og hvor mange tilleggslodd den enkelte aktivitet gir. Ikke alle deltakere vil
            nødvendigvis motta en invitasjon. Scoopr kan endre, legge til eller fjerne
            kvalifiserende aktiviteter i løpet av Trekningsperioden, forutsatt at endringen
            kommuniseres til berørte deltakere i den aktuelle invitasjonen.
          </p>
          <p>
            Deltakelse er frivillig og påvirker ikke deltakerens grunnlodd eller øvrige rettigheter
            etter disse vilkårene. Gjennomføring av en aktivitet innebærer ingen forpliktelse til å
            benytte et lånetilbud.
          </p>

          <h3>1.5 – Ansvarlig arrangør og tredjeparter</h3>
          <p>Det er Scoopr som er arrangør av trekningen.</p>
          <p>
            Trekningen støttes eller sponses ikke av noen tredjepart. Det opplyses særskilt om at
            trekningen verken støttes eller sponses av Meta, TikTok, Snapchat eller Google, selv om
            markedsføring skulle foregå gjennom disse kanalene. Deltakere kan ikke rette noen krav
            mot slike tredjeparter i forbindelse med konkurransen.
          </p>

          <h3>1.6 – Deltakerens låneforhold</h3>
          <p>
            Ved refinansiering avslutter deltakeren sitt tidligere låneforhold og erstatter det med
            et nytt. Lånevilkårene, inkludert lånets type, løpetid og renter, kan endres ved en
            refinansiering. Deltakeren er selv ansvarlig for å sette seg inn i de nye lånevilkårene.
          </p>
          <p>
            Scoopr er ikke part i verken det tidligere eller nye låneforholdet og kan derfor ikke
            holdes ansvarlig for verken deltakerens eller låneformidlerens avtalte plikter.
          </p>

          <h3>1.7 – Personopplysninger</h3>
          <p>
            I forbindelse med deltakelse vil Scoopr behandle personopplysninger. Personopplysningene
            benyttes til å registrere «Min Scoopr»-bruker, kontrollere overholdelse av vilkår og
            utnevne og kontakte vinneren.
          </p>
          <p>
            Scoopr behandler også opplysninger fra Gjeldsregisteret. Samtykket kan trekkes tilbake
            når som helst på{' '}
            <a href="https://www.gjeldsregisteret.com/" target="_blank" rel="noreferrer">
              www.gjeldsregisteret.com
            </a>
            .
          </p>
          <p>
            Scoopr behandler opplysninger om deltakerens tilbudsstatus og gjennomføring av
            kampanjeaktiviteter etter punkt 1.4b. Slik behandling skjer på grunnlag av berettiget
            interesse, jf. personvernforordningen art. 6(1)(f), for å administrere trekningen og
            re-engasjere deltakere med aktive tilbud.
          </p>
          <p>
            I løpet av Trekningsperioden kan Scoopr sende informasjon på e-post og SMS for å minne
            om trekningen og gi informasjon om trekning og vinnere. Vinnere vil aldri bli annonsert
            med fullt navn, med mindre vinneren har samtykket til dette.
          </p>
          <p>
            Dersom deltakeren har takket ja til å motta markedsføring fra Scoopr, vil det sendes
            markedsføring til vedkommende i etterkant av Trekningsperioden.
          </p>
          <p>
            Opplysningene om deltakere lagres så lenge Trekningsperioden varer og i en viss periode
            etter for å kunne påvise at Scoopr har overholdt lovpålagte krav. Opplysningene
            registrert i Min Scoopr oppbevares frem til brukeren sletter sin profil.
          </p>
          <p>
            Opplysningene kan bli delt med andre selskaper i Scoopr-konsernet for formålene
            beskrevet over. Se mer informasjon i Scooprs{' '}
            <Link to={routes.PRIVACY_STATEMENT}>personvernerklæring</Link>.
          </p>

          <h3>1.8 – Avbryte</h3>
          <p>
            Dersom uforutsette hendelser skulle oppstå som Scoopr ikke med rimelighet kunne forutse
            ved igangsetting av trekningen, forbeholder Scoopr seg retten til å avbryte konkurransen
            med fremtidig virkning. Scoopr vil likevel tildele premier til vinnere som allerede er
            trukket og så langt mulig varsle deltakere og gi deltakere mulighet til avregistrering
            og avslutning av Min Scoopr-brukeren.
          </p>

          <h3>1.9 – Henvendelser</h3>
          <p>
            Dersom deltakeren har spørsmål om disse vilkårene eller andre forhold kan Scoopr AS, med
            adresse Karenslyst Allé 2, 0278 Oslo, kontaktes på telefon{' '}
            <a href="tel:48846665">488 46 665</a> eller på e-post:{' '}
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>.
          </p>

          <br />
          <h4>Scoopr AS</h4>
          <p>
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
          <p>Karenslyst Allé 2</p>
          <p>0278 Oslo</p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
